import { useSelector } from 'react-redux';
import MinMaxCateringMessage from '../min-max-catering-message.component';
import {
  selectRequestedStoreMaxValue,
  selectRequestedStoreMinValue,
} from 'redux/locations/locations.selectors';
import { PICKUP } from 'util/constants';

const CateringPickupMessage = ({ storeId }) => {
  const pickupMin = useSelector(state =>
    selectRequestedStoreMinValue(state, storeId, PICKUP),
  );
  const pickupMax = useSelector(state =>
    selectRequestedStoreMaxValue(state, storeId, PICKUP),
  );

  return (
    <MinMaxCateringMessage
      translationString="locations.card.catering.minMax.pickup"
      min={pickupMin}
      max={pickupMax}
      data-testid="CateringPickupMessage.MinMaxCateringMessage"
    />
  );
};

export default CateringPickupMessage;
